import { isProductoPesoManual, TIPO_VENTA_PESO_MANUAL } from './pesoManualVenta';

export const TIPO_VENTA_MODO_UNIDAD = 'unidad';
export const TIPO_VENTA_MODO_PESO = 'peso';

/** Lee modo UI desde producto existente (misma lógica que el cajero). */
export function readTipoVentaModoFromProducto(producto) {
  return isProductoPesoManual(producto) ? TIPO_VENTA_MODO_PESO : TIPO_VENTA_MODO_UNIDAD;
}

/** Campos que persiste Administración (contrato del cajero). */
export function buildTipoVentaPersistFields(modo) {
  const esPeso = modo === TIPO_VENTA_MODO_PESO;
  return {
    manualWeight: esPeso,
    manual_weight: esPeso,
    tipoVenta: esPeso ? TIPO_VENTA_PESO_MANUAL : '',
    tipo_venta: esPeso ? TIPO_VENTA_PESO_MANUAL : ''
  };
}
